import { AppRouteProps } from "@harea/component";
import { GroupsDetailsContainer } from "./container/GroupsDetailsContainer";
import { GroupsDetailsViewRoutes } from "./views/GroupsDetailsViewRoutes";

export const GroupsDetailsRoutes: Array<AppRouteProps> = [
    {
        path: "user/organisation/:id/groups/:groupId",
        title: "BSM.UserManagement.Groups.Details.Title",
        hideBreadcrumb: true,
        element: <GroupsDetailsContainer />,
        children: [
            ...GroupsDetailsViewRoutes
        ]
    },
];
